(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lyn-jvip-callout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lyn-jvip-timer')) {
    customElements.define('lyn-jvip-timer', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.out = this.querySelector('strong') || this;
        if (Number.isNaN(this.end)) return;
        this.tick();
        this.t = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
      tick() {
        const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        const pad = (n) => String(n).padStart(2, '0');
        const h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        this.out.textContent = h >= 24 ? `${Math.floor(h / 24)}j ${pad(h % 24)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
        if (left === 0) clearInterval(this.t);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lyn-jvip-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!customElements.get('lyn-jvip-timer')) {
      customElements.define('lyn-jvip-timer', class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          this.out = this.querySelector('strong') || this;
          if (Number.isNaN(this.end)) return;
          this.tick();
          this.t = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() { clearInterval(this.t); }
        tick() {
          const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const pad = (n) => String(n).padStart(2, '0');
          const h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
          this.out.textContent = h >= 24 ? `${Math.floor(h / 24)}j ${pad(h % 24)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
          if (left === 0) clearInterval(this.t);
        }
      });
    }

    if (customElements.get('lyn-jvip-selector')) return;
    customElements.define('lyn-jvip-selector', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add]');
        this.totalEl = this.querySelector('[data-total]');
        this.errorEl = this.querySelector('.lyn-jvs__error');
        this.querySelectorAll('.lynae-offers__radio').forEach((r) => r.addEventListener('change', () => this.update()));
        this.button.addEventListener('click', () => this.add());
        if (!this.selected()) this.querySelector('.lynae-offers__radio')?.click();
        this.update();
      }

      selected() {
        return this.querySelector('.lynae-offers__radio:checked');
      }

      update() {
        const r = this.selected();
        if (!r) return;
        const qty = Number(r.dataset.qty);
        if (this.totalEl) this.totalEl.textContent = r.dataset.total;
        this.querySelectorAll('[data-gift-minimum]').forEach((g) => {
          const unlocked = qty >= Number(g.dataset.giftMinimum);
          g.classList.toggle('lynae-offers__gift--locked', !unlocked);
          g.querySelectorAll('[data-unlocked]').forEach((el) => (el.hidden = !unlocked));
          g.querySelectorAll('[data-locked]').forEach((el) => (el.hidden = unlocked));
        });
      }

      async add() {
        const r = this.selected();
        if (!r || this.button.disabled) return;
        const qty = Number(r.dataset.qty);
        this.errorEl.hidden = true;
        this.setAttribute('aria-busy', 'true');
        const items = [{ id: Number(this.dataset.variant), quantity: qty, properties: { _offre_vip: qty + ' flacon(s)' } }];
        this.querySelectorAll('[data-gift-variant]').forEach((g) => {
          if (qty >= Number(g.dataset.giftMinimum)) items.push({ id: Number(g.dataset.giftVariant), quantity: 1, properties: { _cadeau_vip: 'oui' } });
        });
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('cart ' + res.status);
          window.dispatchEvent(new CustomEvent('lyn:jvip-add', { detail: { quantity: qty } }));
          const after = this.dataset.after === 'checkout' ? '/checkout' : '/cart';
          const code = r.dataset.code;
          window.location.href = code ? `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(after)}` : after;
        } catch (e) {
          this.errorEl.hidden = false;
          this.removeAttribute('aria-busy');
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lyn-vp-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!customElements.get('lyn-jvip-timer')) {
      customElements.define('lyn-jvip-timer', class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          this.out = this.querySelector('strong') || this;
          if (Number.isNaN(this.end)) return;
          this.tick();
          this.t = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() { clearInterval(this.t); }
        tick() {
          const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const pad = (n) => String(n).padStart(2, '0');
          const h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
          this.out.textContent = h >= 24 ? `${Math.floor(h / 24)}j ${pad(h % 24)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
          if (left === 0) clearInterval(this.t);
        }
      });
    }

    if (customElements.get('lyn-vp-selector')) return;
    customElements.define('lyn-vp-selector', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add]');
        // Les radios portent aussi data-total : cibler le span du bouton.
        this.totalEl = this.querySelector('.lyn-jvs__total');
        this.errorEl = this.querySelector('.lyn-jvs__error');
        this.querySelectorAll('.lynae-offers__radio').forEach((r) => r.addEventListener('change', () => this.update()));
        this.button.addEventListener('click', () => this.add());
        // Le navigateur peut restaurer le dernier choix au rechargement : revenir à l'offre par défaut.
        this.resetToDefault();
        window.addEventListener('pageshow', () => this.resetToDefault());
      }

      resetToDefault() {
        const def = this.querySelector('.lynae-offers__radio[checked]:not(:disabled)') || this.querySelector('.lynae-offers__radio:not(:disabled)');
        if (def) def.checked = true;
        this.update();
      }

      selected() {
        return this.querySelector('.lynae-offers__radio:checked');
      }

      update() {
        const r = this.selected();
        if (!r) return;
        const qty = Number(r.dataset.qty);
        if (this.totalEl) this.totalEl.textContent = r.dataset.total;
        this.querySelectorAll('[data-gift-minimum]').forEach((g) => {
          const unlocked = qty >= Number(g.dataset.giftMinimum);
          g.classList.toggle('lynae-offers__gift--locked', !unlocked);
          g.querySelectorAll('[data-unlocked]').forEach((el) => (el.hidden = !unlocked));
          g.querySelectorAll('[data-locked]').forEach((el) => (el.hidden = unlocked));
        });
      }

      async add() {
        const r = this.selected();
        if (!r || this.button.disabled) return;
        const qty = Number(r.dataset.qty);
        this.errorEl.hidden = true;
        this.setAttribute('aria-busy', 'true');
        // Une seule ligne : la variante du pack, au prix du pack.
        const items = [{ id: Number(r.dataset.variant), quantity: 1, properties: { _offre_vp: r.dataset.title } }];
        this.querySelectorAll('[data-gift-variant]').forEach((g) => {
          if (qty >= Number(g.dataset.giftMinimum)) items.push({ id: Number(g.dataset.giftVariant), quantity: 1, properties: { _cadeau_vip: 'oui' } });
        });
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('cart ' + res.status);
          window.dispatchEvent(new CustomEvent('lyn:vp-add', { detail: { quantity: qty } }));
          const code = r.dataset.code;
          if (this.dataset.after === 'checkout') {
            window.location.href = code ? `/discount/${encodeURIComponent(code)}?redirect=/checkout` : '/checkout';
            return;
          }
          // Panier : on ouvre uniquement le panier latéral Kaching, sans quitter la page.
          if (code) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: code }),
            }).catch(() => {});
          }
          if (typeof window.kachingCartApi?.openCart === 'function') {
            window.kachingCartApi.openCart({ refetchCart: true });
          } else if (document.querySelector('kaching-cart')) {
            document.dispatchEvent(new CustomEvent('kaching-cart:open', { detail: { element: this, cartOpenSource: 'cart-button' } }));
          } else {
            window.location.href = '/cart';
            return;
          }
          this.removeAttribute('aria-busy');
        } catch (e) {
          this.errorEl.hidden = false;
          this.removeAttribute('aria-busy');
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
